import bannersModule from '@gin-betting/banners';

import * as utils from './utils';

export type { BannerTypes } from '@gin-betting/banners';

export default {
    ...bannersModule,
    utils: {
        ...bannersModule.utils,
        ...utils,
    },
};
